"use strict";

exports.__esModule = true;
exports.NavigationFrame = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _excluded = ["children", "initialURL"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Empty route context so a nested MemoryRouter is not treated as a descendant
 * of the app HashRouter (RR6 forbids nested <Router>s).
 */
var DETACHED_ROUTE_CONTEXT = {
  outlet: null,
  matches: [],
  isDataRoute: false
};

/**
 * Provides a separate router which does not affect the browser's navigation controls or address bar.
 * Allows using real links to navigate within panels without affecting the main screen.
 */
var NavigationFrame = exports.NavigationFrame = /*#__PURE__*/function (_Component) {
  function NavigationFrame() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(NavigationFrame, _Component);
  var _proto = NavigationFrame.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      initialURL = _this$props.initialURL,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    // Remount when initialURL changes so nested panel navigation resets.
    // Clear parent RR contexts first — RR6 throws if MemoryRouter sits under HashRouter.
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.UNSAFE_LocationContext.Provider, {
      value: null
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.UNSAFE_NavigationContext.Provider, {
      value: null
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.UNSAFE_RouteContext.Provider, {
      value: DETACHED_ROUTE_CONTEXT
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.MemoryRouter, _extends({
      key: initialURL,
      initialEntries: [initialURL],
      initialIndex: 0
    }, extra), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children)))));
  };
  return NavigationFrame;
}(_react.Component);